import React from 'react';

export default function BrandLockup({ compact = false, className = '' }) {
  return (
    <div className={`brand-lockup ${compact ? 'brand-lockup-compact' : ''} ${className}`.trim()}>
      <img className="brand-mark" src="/assess-reconcile-mark.svg" alt="Assess & Reconcile" />
      <span className="brand-copy">
        <span className="brand-name">Assess <span className="brand-ampersand">&amp;</span> Reconcile</span>
        {!compact && <span className="brand-tagline">Xero bookkeeping intelligence</span>}
      </span>
    </div>
  );
}
